module.exports = __webpack_public_path__ + "img/03_max_exposure.49cbd3d9.svg";